import {Component, OnInit, TemplateRef} from '@angular/core';
import {base_prix} from "../../../../model/db";
import {ActivatedRoute} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {valuesys} from "../../../../../../options";
import Swal from 'sweetalert2' ;
import {Translatable} from "../../../../../Translatable";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";

@Component({
  selector: 'app-base-prix',
  templateUrl: './base-prix.component.html',
  styleUrls: ['./base-prix.component.css']
})
export class BasePrixComponent extends Translatable implements OnInit {

  title:string ;
  dtOptions: DataTables.Settings = {};

  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  modalRef: BsModalRef;

  public type_branchement = [];

  public bases_prix:base_prix [] = [];
  public base_prix:base_prix  = new base_prix();
  base_prix_error: base_prix;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService
  ) { 
    super();
  }

  async ngOnInit() {
    this.auth.initAutority("BAP");

    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_users");
    this.initDatatable()
    //console.log(" liste des droits "+this.listeModules);


  }

  initDatatable(){
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {data:"fix"},
      {data:"pu_cable"},
      {data:"pu_surfacade"},
      {data:"label"}
    ]  ;
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
          .get<DataTablesResponse>(
              environment.base_prix +"?child=type_branchement&"+  $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
          ).subscribe(resp => {
        this.bases_prix = resp.data;
        console.log(resp)
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }

  async addUserForm(){
    this.isValid = true ;
    if(this.isAdd ){
      console.log(this.base_prix);
      let res =  await this.http.post<any>( environment.base_prix,this.base_prix,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        //this.rerender();
        this.bases_prix.push(res.data);
        this.close()
      }else if(res.code === 400){
        this.base_prix_error = <base_prix> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {

      console.log("FAL PROF",this.base_prix);
      let res =  await this.http.put<any>( environment.base_prix + '/' + this.base_prix.id,this.base_prix,valuesys.httpAuthOptions()).toPromise();

      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;

        this.close()
      }else if(res.code === 400){
        this.base_prix_error = <base_prix> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;

    let res = await this.http.get<any>(environment.base_prix +"?child=type_branchement",valuesys.httpAuthOptions()).toPromise();
    this.bases_prix = res.data;

  }

  async openModal(template: TemplateRef<any>,currentbase_prix:base_prix =null,btn:any) {
    btn.disabled= true
    this.base_prix_error = new base_prix();
    this.type_branchement = await this.helper.getSelectList(environment.type_branchement,['label']);

    if(currentbase_prix == null){
      this.base_prix = new base_prix();
      this.isAdd = true ;
      this.titleModal = this.__('base_prix.add') ;
    }else {
      this.isAdd = false ;
      this.titleModal = this.__('base_prix.edit') ;
      let res = await this.http.get<any>(environment.base_prix + '/' + currentbase_prix.id,valuesys.httpAuthOptions()).toPromise();
      this.base_prix = currentbase_prix ;

    }
    btn.disabled= false

    this.modalRef = this.modalService.show(template,{ignoreBackdropClick:true});
  }

  close(){
    this.base_prix_error = new base_prix();
    this.base_prix = new base_prix();
    this.titleModal = "" ;
    this.modalRef.hide()
  }

  delete(deletebase_prix:base_prix,btn:any){
    btn.disabled= true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.base_prix+"/"+deletebase_prix.id,valuesys.httpAuthOptions()).toPromise();
        if(sup.code == 204){
          this.bases_prix= this.bases_prix.filter(function (item,index) {
            return item.id != deletebase_prix.id
          });
          btn.disabled= false
          Swal.fire(
              this.__('msg.deleted'),
              sup.msg,
              'success'
          )
        }else {
          btn.disabled= false
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
            this.__('msg.canceled'),
            this.__('msg.canceled_delete'),
            'error'
        )
        btn.disabled= false
      }
    })
  }





  async toggleState(type:base_prix,state:number,btn:any){
  //  console.log(btn.hidden = true)
    $(btn).attr('disabled');
    btn.disabled = true;
    let toogle = await this.http.get<any>( environment.type_piece+`/${type.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      type.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }


}

